import { createAction, props } from '@ngrx/store';
import { MwLoadOptions } from 'app/models/load-options.model';
import { MwPayloadModel } from 'app/models/payload.model';
import { ProductGroupApiModel } from 'app/models/product-group-api.model';

export const loadProductGroups = createAction(
  '[Product groups] Load',
  props<{ loadOptions: MwLoadOptions }>()
);

export const loadProductGroupsSuccess = createAction(
  '[Product groups] Load Successful',
  props<{ response: ProductGroupApiModel[] }>()
);

export const loadProductGroupsFailed = createAction(
  '[Product groups] Load Failed',
  props<{ error: any }>()
);

export const createProductGroup = createAction(
  '[Product groups] Create',
  props<{ productGroup: ProductGroupApiModel }>()
);

export const createProductGroupSuccess = createAction(
  '[Product groups] Create Successful'
);

export const createProductGroupFailed = createAction(
  '[Product groups] Create Failed',
  props<{ error: any }>()
);

export const updateProductGroup = createAction(
  '[Product groups] Update',
  props<{ productGroup: ProductGroupApiModel }>()
);

export const updateProductGroupSuccess = createAction(
  '[Product groups] Update Successful'
);

export const updateProductGroupFailed = createAction(
  '[Product groups] Update Failed',
  props<{ error: any }>()
);

export const deleteProductGroup = createAction(
  '[Product groups] Delete',
  props<{ productGroup: ProductGroupApiModel }>()
);

export const deleteProductGroupSuccess = createAction(
  '[Product groups] Delete Successful'
);

export const deleteProductGroupFailed = createAction(
  '[Product groups] Delete Failed',
  props<{ error: any }>()
);

export const deleteProductGroupsList = createAction(
  '[Product groups] Delete List',
  props<{ productGroups: ProductGroupApiModel[] }>()
);

export const deleteProductGroupsListSuccess = createAction(
  '[Product groups] Delete List Successful'
);

export const deleteProductGroupsListFailed = createAction(
  '[Product groups] Delete List Failed',
  props<{ error: any }>()
);

export const resetProductGroups = createAction('[Product groups] Reset');
